export const compactObject = obj => {
  const rs = {}
  Object.keys(obj).forEach(key => {
    if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
      rs[key] = obj[key]
    }
  })
  return rs
}
